"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _CompletedContext = require("../CompletedContext");

var _Tabs = _interopRequireDefault(require("../Tabs/Tabs"));

require("./TaskTabPanel.scss");

var _util = require("../util");

var _excluded = ["handleTabSelect", "label", "contents"];

function TaskTabPanelTabs(_ref) {
  var handleTabSelect = _ref.handleTabSelect,
      label = _ref.label,
      contents = _ref.contents,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    tabs: contents.map(function (c) {
      return c.title;
    }),
    panels: contents.map(function (c) {
      return c.contents;
    }),
    onChange: handleTabSelect
  });
}

var TaskTabPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskTabPanel, _Component);

  var _super = (0, _createSuper2.default)(TaskTabPanel);

  function TaskTabPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskTabPanel);
    _this = _super.call(this, props);
    _this.state = props.state || {};

    if (!_this.state.initialized) {
      var _props$state;

      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.viewed = new Array(_this.props.contents.length).fill(false);
      _this.state.viewed[0] = true;

      if (props !== null && props !== void 0 && (_props$state = props.state) !== null && _props$state !== void 0 && _props$state.completed) {
        // written verbosely due to babel misinterpretation
        _this.state.completed = true;
      } else {
        _this.state.completed = false;
      }
    }

    _this.handleTabSelect = _this.handleTabSelect.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TaskTabPanel, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "handleTabSelect",
    value: function handleTabSelect(k) {
      var temp = this.state.viewed;
      temp[k] = true;
      var compeletionCheck = temp.every(function (v) {
        return v === true;
      });
      this.setState({
        viewed: temp,
        completed: compeletionCheck
      });

      if (this.props.onTabChange) {
        this.props.onTabChange(k);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.label === undefined) {
        throw new Error("TaskTabPanel: prop 'label' (for the tab navs) must be specified in order for this component to be accessible.");
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.props.style,
        className: "task-tab-panel"
      }, /*#__PURE__*/_react.default.createElement(TaskTabPanelTabs, Object.assign({}, this.props, {
        handleTabSelect: this.handleTabSelect
      })));
    }
  }]);
  return TaskTabPanel;
}(_react.Component);

exports.default = TaskTabPanel;
TaskTabPanel.contextType = _CompletedContext.CompletedContext;